import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import styles from './map.module.scss';
import MapNavigation from './components/MapNavigation';
import './geocoderStyle.scss';
import 'mapbox-gl/dist/mapbox-gl.css';
import { FlyToInterpolator } from '@deck.gl/core';
import MapGL, { NavigationControl, ScaleControl, Marker } from 'react-map-gl';

import MAP_STYLE from './components/mapStyle';
import MarkerItem from './components/Marker/MarkerItem';
import { dealerResponse } from 'store/step3PageDataSlice';
import { getWindowWidth } from 'utils/getWindowWidth';
import {isMd} from "../../api/api";

const cx = classNames.bind(styles);

const MAPBOX_TOKEN =
  'pk.eyJ1IjoidG95b3RhdWtyYWluZSIsImEiOiJja2hkMTQ4ZmkwMGJsMnNrOTZweW54Ymp0In0.0rsD9LUhlKc8ou4GPws5eA';

const MoldovaCoords = {
    longitude: 28.837374,
    latitude: 47.02416,
    zoom: 6.5,
};

const DefaultCoords = {
    longitude: 30.702624263115368,
    latitude: 48.88689275970395,
    zoom: 5.5,
};


const MapComponent = ({ dealerList }) => {
  const width = getWindowWidth();
    const [viewport, setViewport] = useState(
        isMd ? MoldovaCoords : DefaultCoords
    );
  const [activeMarker, setActiveMarker] = useState(null);
  const mapRef = useRef();
  const geocoderRef = useRef();

  const handleViewportChange = useCallback(
    (newViewport) => setViewport(newViewport),
    [],
  );

  const handleGeocoderViewportChange = useCallback(
    (newViewport) => {
      const geocoderDefaultOverrides = { transitionDuration: 1000 };

      return handleViewportChange({
        ...newViewport,
        ...geocoderDefaultOverrides,
      });
    },
    [handleViewportChange],
  );

  const getCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      position &&
        handleViewportChange({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          transitionDuration: 1000,
          zoom: 10,
          transitionInterpolator: new FlyToInterpolator({ speed: 2 }),
        });
    });
  };
  useEffect(() => {
    if (width > 1200) {
      setViewport({
        ...viewport,
          zoom: isMd ? 6.5 : 5.5,
      });
    } else if (width < 1200 && width > 767) {
      setViewport({
        ...viewport,
          zoom: isMd ? 6.5 : 4.5,
      });
    } else if (width < 767) {
      setViewport({
        ...viewport,
          zoom: isMd ? 6 : 4,
      });
    }
  }, [width]);

  return (
    <div className={cx('mapWrap')}>
      <MapGL
        ref={mapRef}
        {...viewport}
        mapboxApiAccessToken={MAPBOX_TOKEN}
        mapStyle={MAP_STYLE}
        onViewportChange={handleViewportChange}
        interactiveLayerIds={['sf-neighborhoods-fill']}
        width="100%"
        height="calc(100vh - 202px)"
      >
        {dealerList &&
          dealerList.map((el, index) => (
            <MarkerItem
              key={index}
              item={el}
              number={index + 1}
              onClickFc={(position) => handleViewportChange(position)}
              activeMarker={activeMarker}
              activeMarkerHandler={(number) => setActiveMarker(number)}
            />
          ))}
        <NavigationControl
          ref={mapRef}
          style={{ position: 'absolute', right: 0, top: 0 }}
        />
        <ScaleControl ref={mapRef} />
      </MapGL>
      <MapNavigation
        onViewportChange={(position) => {
          handleViewportChange(position);
          setActiveMarker(null);
        }}
        fetchLocation={getCurrentLocation}
        mapRef={mapRef}
        geocoderRef={geocoderRef}
        handleGeocoderViewportChange={handleGeocoderViewportChange}
        mapBoxToken={MAPBOX_TOKEN}
      />
    </div>
  );
};

export default MapComponent;
